export enum LeagueEnum {
  PremierLeague = 'premier-league',
  LaLiga = 'la-liga',
  BundesLiga = 'bundesliga',
  SerieA = 'serie-a',
  Liga1 = 'liga-1',
  ChampionsLeague = 'champions-league',
  WorldCup2026 = 'WorldCup2026',
}

export enum RoomType {
  Company = 'company',
  Individual = 'individual',
}

export interface RoomSettings<T = string> {
  _id: string
  roomId: string
  pointRules: {
    predictedWinnerPoint: T
    predictedScorePoint: T
  }
}

export interface Room {
  _id: string
  id?: string // Optional for compatibility with PostgreSQL UUID format
  type: RoomType
  name: string
  players: User[]
  leagues: LeagueEnum[]
  setting: RoomSettings<string>
  owner: {
    _id: string
    name: string
  }
  gameType?: 'football' | 'chess' | 'formula1' | 'golf' | 'academ' | 'math' // Optional: defaults to 'football'
  /** Academ learning subject */
  academSubject?: string
  /** Geography: mixed | flags | capitals */
  academCategory?: string
  agentBanterEnabled?: boolean
  // Chess game settings (from breakroom-chess-react)
  defaultTimeControl?: string
  defaultVariant?: string
  defaultStockfishLevel?: number
  defaultRated?: boolean
  /** Chess room: one of the 7 tournament types or 'none' (from chess_room_settings) */
  chessTournamentType?: string
  /** When chessTournamentType is 'arena', link to chess_arenas (same backend as chess-arenas app) */
  arenaId?: string | null
  createdAt?: Date | string
  updatedAt?: Date | string
}

/** One admin starting-points adjustment (ledger entry). */
export interface StartingPointsEntry {
  id: string
  /** Signed amount: positive = added, negative = subtracted. */
  amount: number
  note?: string | null
  createdAt: string
  setByUserId?: string | null
  setByName?: string | null
}

export interface User {
  _id: string
  name: string
  avatar?: string | null
  predictions: Prediction[]
  roomRole?: string
  // Pre-computed from summary endpoint (fast path)
  totalPoints?: number
  /** Points earned from predictions on this platform (excludes starting points). */
  earnedPoints?: number
  /** Admin-assigned head-start points (football rooms). Included in totalPoints. */
  startingPoints?: number
  winnerPoints?: number
  scorePoints?: number
  predictionCount?: number
  email?: string | null
}

export interface Prediction {
  _id: string
  predictedWinnerPoint?: number | null
  predictedScorePoint?: number | null
  winner?: string | null
  predictedScore?: string
  match?: {
    _id: string
    teamA: string
    teamB: string
    winner: string | null
    score: string
    date: string
    time: string
  }
}
